module.exports = __webpack_public_path__ + "static/24-WHY-THE-FUTURE-OF-WORK-WILL-PLAY-OUT-DIFFERENTLY-IN-AFRICA-ae9bffdec1170391d0f0fd7ac635d700.jpg";